export const SET_COMPANIES = "SET_COMPANIES";
